const useAccordion = () => {
  const accordions = document.querySelectorAll('.accordion')
  if (!accordions.length) return

  accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll('.accordion-item')
    const type = accordion.dataset.accordionType

    items.forEach((item) => {
      const header = item.querySelector('.accordion-item__header')
      if (!header) return

      header.addEventListener('click', () => {
        if (type === 'multiple') {
          item.classList.toggle('is-opened')
        } else {
          const currentItem = item
          items.forEach((item) => {
            if (item !== currentItem) {
              item.classList.remove('is-opened')
              item.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false')
            } else {
              item.classList.toggle('is-opened')
              item.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'true')
            }
          })
        }
      })
    })
  })
}

export { useAccordion }
